import { ScreenAboutLook } from './screens/AboutLook';
import { ScreenAge } from './screens/Age';
import { ScreenBodyShape } from './screens/BodyShape';
import { ScreenCommunicate } from './screens/Communicate';
import { ScreenEmail } from './screens/Email';
import { ScreenEthnicity } from './screens/Ethnicity';
import { ScreenFindAi } from './screens/FindAi';
import { ScreenGender } from './screens/Gender/index';
import { ScreenHairColor } from './screens/HairColor';
import { ScreenInteraction } from './screens/Interaction';
import { ScreenMajorTurnOff } from './screens/MajorTurnOff';
import { ScreenName } from './screens/Name';
import { ScreenObedience } from './screens/Obedience';
import { ScreenPersonality } from './screens/Personality';
import { ScreenSecurity } from './screens/Security';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { LayoutDataType } from './types';

export const layoutSteps = {
  gender: {
    component: ScreenGender,
    images: [],
  },
  age: {
    component: ScreenAge,
    images: [],
  },
  ethnicity: {
    component: ScreenEthnicity,
    images: [],
  },
  find_ai: {
    component: ScreenFindAi,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: [],
  },
  hair_color: {
    component: ScreenHairColor,
    images: [],
  },
  about_look: {
    component: ScreenAboutLook,
    images: [],
  },
  interactions: {
    component: ScreenInteraction,
    images: [],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  obedience: {
    component: ScreenObedience,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  major_turn_off: {
    component: ScreenMajorTurnOff,
    images: [],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  gender: null,
  age: null,
  ethnicity: null,
  body_shape: null,
  hair_color: null,
  interaction: null,
  communicate: null,
  obedience: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  major_turn_off: null,
  send_photos: null,
  name: '',
  characters: [],
  email: '',
};
